import styled from 'styled-components'
import { Media, mbSize } from '../../theme'

export const PaginationWrapper = styled.div<{
  $gap: number
  $gapMb: number
  $marginTop: number
  $marginTopMb: number
}>`
  display: flex;
  gap: ${({ $gap }) => `${$gap}px`};
  margin-top: ${({ $marginTop }) => `${$marginTop}px`};
  position: relative;
  z-index: 5;
  ${Media.lessThan(Media.small)} {
    gap: ${({ $gapMb }) => mbSize($gapMb)};
    margin-top: ${({ $marginTopMb }) => mbSize($marginTopMb)};
  }
`

export const Pagination = styled.div<{
  $active: boolean
  $height: number
  $heightMb: number
  $width: number
  $widthMb: number
  $activeWidth: number
  $activeWidthMb: number
}>`
  transition: all 0.3s;
  background: #cccccc99;
  width: ${({ $active, $width, $activeWidth }) => ($active ? `${$activeWidth}px` : `${$width}px`)};
  height: ${({ $height }) => `${$height}px`};
  border-radius: 20px;
  cursor: pointer;
  overflow: hidden;
  ${Media.lessThan(Media.small)} {
    width: ${({ $active, $widthMb, $activeWidthMb }) =>
      $active ? mbSize($activeWidthMb) : mbSize($widthMb)};
    height: ${({ $heightMb }) => mbSize($heightMb)};
    border-radius: 20px;
  }
`

export const Progress = styled.div<{ $width: string }>`
  background: #f3512b;
  height: 100%;
  width: ${({ $width }) => $width};
  transition: all 0.1s;
`
